import React, {Component} from 'react';
import '../../pages/error/ErrorPage.scss'
import '../../components/error/ErrorMessage.scss'
import {Link} from "../link/Link";
import classNames from "classnames";
import PropTypes from "prop-types";
import {Icon} from "../icon/Icon"
import {getUrlByEnvironment} from "../../../vendor/utils/Utils";

class ErrorMessage extends Component {

  render() {
    const classes = classNames(
      'documents-common box',
      this.props.additionalClasses,
    );

    const {portalUrl, portalLabel} = getUrlByEnvironment();

    let errorText = null;
    switch (this.props.type) {
      case '404':
        errorText = (
          <>
            <h1 className={'error-message__h1'}>404 – SEITE NICHT GEFUNDEN</h1>
            <h2 className={'error-message__h2'}>Hoppla! Diese Seite befindet sich auf Reisen!</h2>
            <div className={'error-message__text-block'}>

              <p>Möglicherweise befindet sich die von Ihnen gesuchte Seite bereits auf einer Traumreise ...<br/>
                Damit auch Ihrer Reise nichts mehr im Wege steht, versuchen Sie bitte zunächst über den Zurück-Pfeil auf
                eine existente Seite zu gelangen.<br/>
                Sollte auch das nicht zum Erfolg führen, klicken Sie bitte folgenden Link: <Link href={portalUrl}
                                                                                                 label={portalLabel}
                                                                                                 target='_self'/>.<br/>
                Sie gelangen dann wieder auf die Startseite des CANUSA-Kundenportals.</p>
            </div>
          </>
        );
        break;
      case 'loadingError':
        errorText = (
          <>
            <h2 className={'error-message__h2'}><Icon name={'warning'} additionalClasses={'error-message__icon'}/>Es ist
              ein Fehler aufgetreten</h2>
            <div className={'error-message__text-block'}>
              <p>Leider haben wir gerade mit technischen Schwierigkeiten zu kämpfen und können Ihnen
                unseren Service derzeit nicht zur Verfügung stellen.</p>
              <p>Wir arbeiten bereits an einer Lösung.
                Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.</p>
            </div>
          </>
        );
        break;
      default:
        errorText = this.props.children
        break;
    }
    return (
      <div className={classes}>
        {errorText}
      </div>
    );
  }
}

ErrorMessage.propTypes = {
  /**
   * type of error message to render
   * @example: '404', 'loadingError'
   */
  type: PropTypes.oneOf(['404', 'loadingError']),
};

export {
  ErrorMessage as default,
  ErrorMessage
}
